import { ErrorMessage, Field, Formik } from "formik";
import React from "react";
import { Button, Modal, Table } from "react-bootstrap";

export default function CommissionDetails({
  initialValues,
  show,
  handleClose,
}) {
  const validationSchema = {};
  const handleSubmit = {};
  const DropdownField = ({ name, options }) => (
    <Field as="select" name={name} className="form-control" disabled>
      {/* {["percentage", "static"]} */}
      <option value={"percentage"}>Percentage</option>
      <option value={"static"}>Static</option>
    </Field>
  );
  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({}) => (
          <Modal show={show} onHide={handleClose} size="xl">
            <Modal.Header closeButton>
              <Modal.Title>Commission Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Table bordered responsive>
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Commission Type</th>
                    <th>Commission Value</th>
                    <th>Markup Type</th>
                    <th>Markup Value</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {["fare", "food", "seat", "baggage"].map((type, index) => (
                    <tr key={index}>
                      <td className="text-capitalize">{type}</td>

                      {/* Commission Type Dropdown */}
                      <td>
                        <DropdownField name={`${type}.commissionType`} />
                      </td>

                      {/* Commission Value */}
                      <td>
                        <Field
                          disabled
                          type="number"
                          name={`${type}.commissionValue`}
                          className="form-control"
                        />
                        <ErrorMessage
                          name={`${type}.commissionValue`}
                          component="div"
                          className="text-danger"
                        />
                      </td>

                      {/* Markup Type Dropdown */}
                      <td>
                        <DropdownField name={`${type}.markupType`} />
                      </td>

                      {/* Markup Value */}
                      <td>
                        <Field
                          disabled
                          type="number"
                          name={`${type}.markupValue`}
                          className="form-control"
                        />
                        <ErrorMessage
                          name={`${type}.markupValue`}
                          component="div"
                          className="text-danger"
                        />
                      </td>

                      {/* Status Checkbox */}
                      <td className="text-center">
                        <Field
                          disabled
                          type="checkbox"
                          name={`${type}.typeStatus`}
                          className="form-check-input"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Formik>
    </div>
  );
}
